import React from 'react';
// import PropTypes from 'prop-types';
import { Box, Text } from 'wt-ui';

const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const formatDate = (dt) => `${weekdays[dt.getDay()]}, ${monthNames[dt.getMonth()]} ${dt.getDate()} ${dt.getFullYear()}`;
// Tuesday, February 4, 2020

const CalendarDateRow = ({ date }) => (
  <Box background="#ced4d9c2" pad="xsmall" style={{ color: '#333' }}>
    <Text color="#333" textAlign="center" weight="600">
      {formatDate(date)}
    </Text>
  </Box>
);

export default CalendarDateRow;
